const colorData =['#405199','#3D56A7','#3B5CB7','#3861C3','#3666D2','#346CE1','#3070ED','#2F7AF7','#2F87F6','#2F99F7','#2FA6F6','#2EB7F5','#2EC6F5','#2ED7F5','#2DE2F0','#2AE5E2','#28E8D4','#25EBC4','#22EEB6','#20F1A8','#28F298','#49ED81','#6CE867','#88E554','#A6E03F','#C6DC28','#E5D712','#FFD200','#FFCC00','#FFC500','#FFBF00','#FFB700','#FFB100','#FFAA00','#FE9C00','#FC8900','#FA7400','#F85F00','#F64B00','#F43800','#F32200', '#F10F00','#EE0000','#E90000', '#E40000', '#E00000', '#DB0000', '#D60000', '#D20000','#CD0000','#C90000','#C50000','#C00000','#BC0000', '#B60000', '#B20000', '#AD0000'  , '#A90000', '#A40000', '#9F0000']
const returnColor = (arr, isTrue) => {
  var maxNum = colorData.length * 2700
  var maxNumr = colorData.length * 500
  if (arr.length > 0) {
    var maxTotal = arr[0].dayOperate
  }
  for (var v of arr) {
    if (isTrue) {
      v.percentage = (v.dayOperate / maxTotal) * 100
      if (v.dayOperate >= maxNum) {
        v.color = colorData[colorData.length - 1]
      } else if (v.dayOperate < maxNum) {
        v.color = colorData[parseInt(parseInt(v.dayOperate) / 2700)]
      }
    } else {
      if (parseInt(v.total) >= maxNumr) {
        v.color = colorData[colorData.length - 1]
      } else if (parseInt(v.total) < maxNumr) {
        v.color = colorData[parseInt(parseInt(v.total) / 500)]
      }
    }
  }
  return arr
}
const returnAreaColor = (arr) => {
  // const colorData = ['#03D2F9', '#0FDDE1', '#16E4D0', '#20EDBC', '#29F5A8', '#32FE95', '#53F77C', '#84EE59', '#B4E437', '#EAD910',
  //   '#FFCD00', '#FFBE00', '#FFAE00', '#FF9C00', '#FF8A00', '#FF7900', '#F25B00', '#E84200', '#DD2800', '#D20F00']
  var maxNum = colorData.length * 6000, getObjColor = {}
  for (var v of arr) {
    if (v.total >= maxNum) {
      v.color = colorData[colorData.length - 1]
    } else if (parseInt(v.total) < maxNum) {
      v.color = colorData[parseInt(parseInt(v.total) / 2700)]
    }
    getObjColor[v.cityCode] = v.color
  }
  return getObjColor
}
export default {
  returnColor: returnColor,
  returnAreaColor: returnAreaColor,
  colorData: colorData
}
